module.exports = __webpack_public_path__ + "img/third.a7eb8aa3.png";